import React from 'react';
import HostActions from './HostPortalActions';
import {TextField, SelectField} from 'form-fields';
import {Tooltip} from 'react-bootstrap';

export default class AddGuest extends React.Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	isValid() {
		return this.refs.GuestName.isValid() && this.refs.EmailAddress.isValid()
	}

	validateEmail() {
		let submitData = {
			EventCode: this.props.selectedEventDetails.code,
			Name: this.props.AddGuest_GuestName,
			Email: this.props.AddGuest_GuestEmailAddress
		};
		HostActions.validateGuest(submitData);
	}

	registerErrors() {
		this.refs.GuestName.registerErrors()
		this.refs.EmailAddress.registerErrors()
	}

	canSubmit() {
		return this.props.AddGuest_GuestName.length > 0 && (this.props.selectedEventDetails.isVirtual ? this.props.AddGuest_GuestEmailAddress.length > 0 : true)
	}

	addGuest() {
		if (this.isValid()) {
			this.validateEmail()
		} else {
			this.registerErrors();
		}
	}

	render() {
		if(this.props.selectedEventDetails.eventStatus !== "Active") return null;
		let Rules = {
			GuestName: {
				required: true,
				requiredMessage: this.props.resources['PWS.MyAccount.GuestsTabGuestNameRequiredMessage']
			},
			EmailAddress: {
				required: this.props.selectedEventDetails.isVirtual,
				requiredMessage: this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressRequiredMessage'],
				email: true,
				emailMessage: this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressInvalidMessage']
			}
		}

		let tooltipMessage = this.props.selectedEventDetails.isVirtual ? this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressNoAddVirtualMessage'].replace('{0}', this.props.resources['PWS.Profile.CompanyName']) : this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressNoAddPhysicalMessage'].replace('{0}', this.props.resources['PWS.Profile.CompanyName']);

		return (
			<div className="clearfix">
				<div className="formSectionSubTitle">{this.props.resources['PWS.MyAccount.GuestsTabAddAGuestLabel']}</div>
				<TextField
					ref="GuestName"
					name="AddGuest_GuestName"
					classes="input-33"
					label={this.props.resources['PWS.MyAccount.GuestsTabGuestNameLabel']}
					value={this.props.AddGuest_GuestName}
					handleChange={HostActions.changeField}
					Rules={Rules.GuestName}
				/>
				<TextField
					ref="EmailAddress"
					name="AddGuest_GuestEmailAddress"
					classes="input-33"
					alwaysShowTooltip={!this.props.validGuestEmail}
					tooltip={this.props.validGuestEmail ? null : tooltipMessage}
					label={this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressLabel']}
					value={this.props.AddGuest_GuestEmailAddress}
					handleChange={HostActions.changeField}
					handleFocus={HostActions.resetValidGuestEmail}
					Rules={Rules.EmailAddress}
				/>
				<div id="addGuestButton" className={this.canSubmit() ? "input-33XXX bookPartyBtn" : "input-33XXX bookPartyBtn disabled-button"} style={{marginTop: 0}} onClick={this.addGuest.bind(this)}>{this.props.resources['PWS.MyAccount.GuestsTabAddToListButton']}</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/AddGuest.js